"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConfirmDeleteDialog = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _defaultTranslations = require("../constants/defaultTranslations");
var _useTranslations = require("../hooks/useTranslations");
var _models = require("../models");
var _FormattedMessage = require("./FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const ButtonCancel = (0, _mui.styled)(_components.Button)({
  textDecoration: 'underline',
  '&:hover, &:focus': {
    background: 'inherit',
    textDecoration: 'underline',
    boxShadow: 'none'
  }
});
const ConfirmDeleteDialog = props => {
  const {
    handleCancel,
    opened,
    disabled,
    children,
    handleConfirm,
    header
  } = props;
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.FeedbackDialog, {
    hideCloseButton: true,
    color: "error",
    severity: "error",
    header: formatMessage(header),
    open: opened,
    actions: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
      fullWidth: true,
      color: "error",
      variant: "contained",
      "data-testid": getTestId('delete-dialog-delete-button'),
      onClick: handleConfirm,
      disabled: disabled,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: _models.TranslationKey.delete,
        defaultMessage: _defaultTranslations.defaultTranslations.delete
      })
    }, "accept"), /*#__PURE__*/(0, _jsxRuntime.jsx)(ButtonCancel, {
      fullWidth: true,
      "data-testid": getTestId('delete-dialog-cancel-button'),
      onClick: handleCancel,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: _models.TranslationKey.cancel,
        defaultMessage: _defaultTranslations.defaultTranslations.cancel
      })
    }, "cancel")],
    "data-testid": getTestId('delete-dialog'),
    onClose: handleCancel,
    children: children
  });
};
exports.ConfirmDeleteDialog = ConfirmDeleteDialog;
//# sourceMappingURL=ConfirmDeleteDialog.js.map